import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class MoveListService {

  /** Item being moved*/
  public movingItem;
  /** Index of the item being moved*/
  movingItemIndex;
  /** Id of the list the move operation originated from*/
  listId;
  /** Subject for move requeest subscriptions*/
  private moveUpdates = new Subject<any>();
  /** Subject for duplicate requeest subscriptions*/
  private duplicateUpdates = new Subject<any>();

  /**
   * Watch for an external move item initiation, this will aloow any needed moves to be triggered form outside the list component*/
  moveUpdatesListener() {
    return this.moveUpdates;
  }
  /**
   * Start an external move item initiation, this will trigger a move operation from any lists that contain the item
   * @param info Data item to be moved
   * @param duplicat Duplicate the item to be moved
   */
  requestMove(info, duplicate?: boolean) {
    if (!info) {
      this.cancelMove();
    }
    if (duplicate) {
      this.duplicateUpdates.next(info);
    } else {
      this.moveUpdates.next(info);
    }
  }
  /**
   *  Watch for an external duplication item initiation,
   *  this will aloow any needed duplications to be triggered form outside the list component */
  duplicateUpdatesListener() {
    return this.duplicateUpdates;
  }

  /**
  * Init a move for a data item, Reposition as child or move to a different parent
  * @param listId List the item is currently in
  * @param info Data item to move
  * @param index Index the item currently exists at
  */
  setMoveItem(listId, info, index) {
    this.listId = listId;
    this.movingItem = info;
    this.movingItemIndex = index;
  }
  /**
   *Clear any active move details
   * */
  cancelMove() {
    this.listId = undefined;
    this.movingItem = undefined;
    this.movingItemIndex = undefined;
  }

}
